<template>
   <table class="table table-sm">
      <thead>
        <th>عنوان</th>
        <th>مقدار</th>
      </thead>
      <tbody>
        <tr v-for="(n, i) in banches" :key="i">
          <td class="small">{{ ttlArr[i] }}</td>
          <td class="small">{{ n }}</td>
        </tr>
        <tr v-for="(n, i) in cuLines" :key="i">
          <td class="small">{{ ttlArr[i] }}</td>
          <td class="small">{{ n }}</td>
        </tr>
      </tbody>
    </table>
</template>

<script>
import { ApiTls } from "../../src/app/tools/ApiTls";
import { LineTls } from "../app/tools/LineTls";
import { PoleTls } from "../app/tools/PoleTls";

export default {
name:'FeederTotalCal',
props:['feederId'],
data(){
    return{
        myData: { linesArr: [], feeder: [], a_sub: [], polesArr: [], l_sub: [] },
ttlArr: {
        n_branch_1ph: "تکفاز",
        n_branch_3ph: "سه فاز",
        l_branch: "متراژ",
        n_branch_light: "روشنایی",
        n_branch_con: "کابل مجتمع",
        "LV-Wire-Cu-6": "مس 6",
        "LV-Wire-Cu-10": "مس 10",
        "LV-Wire-Cu-16": "مس 16",
        "LV-Wire-Cu-25": "مس 25",
        "LV-Wire-Cu-35": "مس 35",
        "LV-Wire-Cu-50": "مس 50",
        new_ssc: "متراژ جدید",
      },
    }
},
mounted() {
    ApiTls.getFeederData(this.feederId, this.setResData);
  },
    methods: {
    setResData(res) {
      this.myData = res.data;
    },
  },
  computed: {
    banches() {
      return PoleTls.sumBranches(this.myData.polesArr);
    },
    cuLines() {
      return LineTls.sumCuLines(this.myData.linesArr);
    },
    toShow() {
      return this.myData.real_length > 0;
    },

  },
  watch: {
   
  },
}
</script>

<style>

</style>